import React, { createContext, useContext, useState, useEffect } from "react";
import { useProfile } from "./ProfileContext";

const BudgetContext = createContext();

export const useBudget = () => useContext(BudgetContext);

export const BudgetProvider = ({ children }) => {
    const { profile } = useProfile();
    const [budget, setBudget] = useState(0.0);

    useEffect(() => {
        fetchProfile();
    }, [profile]);

    useEffect(() => {
        const handler = (e) => {
            const value = Number(e.detail);
            if (Number.isFinite(value)) setBudget(value);
        };

        window.addEventListener("budgetUpdated", handler);
        return () => window.removeEventListener("budgetUpdated", handler);
    }, []);


    const fetchProfile = async () => {
        setBudget(Number(profile?.budget) || 0);
    };

    return (
        <BudgetContext.Provider value={{ budget, setBudget }}>
            {children}
        </BudgetContext.Provider>
    );
};
